import React from 'react'
import { ScrollView } from 'react-native'
import type { GameConfig, MapDef } from '@warcarp/api-types'
import { FloatingGamePanel } from './FloatingGamePanel'
import { GameConfigContent } from './GameConfigContent'
import { useWebModalHistory } from '../../hooks/useWebModalHistory'

type RulesContentProps = { config?: Partial<GameConfig>; map?: MapDef | null; players: string; bootAfterSeconds?: number; hideSpecialRules?: boolean }

/** Identical rules content/spacing in the lobby and active-game menu. */
export function GameRulesPanelContent(props: RulesContentProps) {
  // Thin top: the panel's close strip sits right above.
  return <ScrollView testID="game-menu-config-modal" contentContainerStyle={{ paddingHorizontal: 14, paddingBottom: 14, paddingTop: 2 }}>
    <GameConfigContent {...props} bare />
  </ScrollView>
}

export function GameRulesModal({ visible, onClose, ...props }: RulesContentProps & { visible: boolean; onClose: () => void }) {
  useWebModalHistory({ visible, canDismiss: true, onDismiss: onClose })
  return <FloatingGamePanel visible={visible} onClose={onClose} closeLabel="Close game rules" closeTestID="lobby-rules-close">
    <GameRulesPanelContent {...props} />
  </FloatingGamePanel>
}
